var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",style:(_vm.iconStyle),attrs:{"viewBox":_vm.viewBox}},[_c('path',{attrs:{"fill":_vm.fill || '#000000',"d":_vm.path}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }